import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
import { LanguageContext } from '../Language/LanguageContext'
import dayjs from 'dayjs'

export default function UpcommingSection(props){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.home
    const isLoading = props.isLoading || false
    const event = props.event

    const convertDate = (date) =>{
        let toDate = new Date(date)
        let formattedDate = dayjs(toDate).format("D MMM HH:mm")
        return formattedDate
    }

    const convertDay = (date) =>{
        let toDate = new Date(date)
        let formattedDate = dayjs(toDate).format("D")
        return formattedDate
    }

    const convertInWeek = (date) =>{
        let toDate = new Date(date)
        let formattedDate = dayjs(toDate).format("dddd")
        return formattedDate
    }

    const convertMonth = (date) =>{
        let toDate = new Date(date)
        let formattedDate = dayjs(toDate).format("MMMM")
        return formattedDate
    }

    return(
        <div className="section">
            { isLoading ?
            <div className="loading-section">
                <Spinner 
                variant="primary" 
                animation="border"
                size="sm"
                />
            </div> : null
            }
            <div className="section-title">{lang.up_comming}</div>
             
             <div className="event-container">
                <div className="calendar">
                    <div className="in-week">
                        { event !== null ?
                        convertInWeek(event.eventStart || "1/1/2020") :
                        convertInWeek(new Date())
                        }
                    </div>
                    <div className="month">
                        {event !== null ? convertMonth(event.eventStart || "1/1/2020")
                        : convertMonth(new Date())
                        }
                    </div>
                    <div className="large-date">
                        { event !== null ?
                        convertDay(event.eventStart || "1/1/2020") :
                        convertDay(new Date())
                        }
                    </div>
                    
                </div>
                <div className="detail">
                    { event !== null ?
                        <>
                        <div className="title">{event.title}</div>
                        { !event.allDay ?
                        <div className="date desc">{
                            convertDate(event.eventStart) + " - " + convertDate(event.eventEnd)
                        }
                        </div>
                        : null
                        }
                        <div className="desc description">{event.description}</div>
                        </>
                        :
                        <div>
                            {lang.no_upcomming}
                        </div>
                    }
                </div>
             </div>
             <div style={{marginTop: 20, textAlign: 'center'}}>
                <Link to="/calendar" className="link-section">
                    {lang.see_more_calendar}
                </Link>
            </div>
        </div>
    )
}
